import { produce } from 'immer';

const INITIAL_STATE = {
  configs: null,
  loading: false,
  isSubmitting: false,
};

export default function renotarizations(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@renotarizations/GET_TIMESTAMP_CONFIGS_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@renotarizations/GET_TIMESTAMP_CONFIGS_SUCCESS': {
        draft.configs = action.payload.configs;
        draft.loading = false;
        break;
      }
      case '@renotarizations/UPDATE_TIMESTAMP_CONFIG_REQUEST': {
        draft.isSubmitting = true;
        break;
      }
      case '@renotarizations/UPDATE_TIMESTAMP_CONFIG_SUCCESS': {
        const { index, config } = action.payload;
        if (draft.configs && index >= 0) {
          draft.configs[index] = config;
        }
        draft.isSubmitting = false;
        break;
      }
      case '@renotarizations/RENOTARIZATIONS_FAILURE': {
        draft.loading = false;
        draft.isSubmitting = false;
        break;
      }
      default:
    }
  });
}
